export const keysLS = {
  langData: 'langData',

  supplierListTableParams: 'supplierListTableParams',
  supplierListFilterParams: 'supplierListFilterParams',
  supplierListFilterIsExpand: 'supplierListFilterIsExpand',

  inspectionListTableParams: 'inspectionListTableParams',
  inspectionListFilterParams: 'inspectionListFilterParams',

  factoryAuditListParams: 'factoryAuditListParams',

  onBoardingFormTouched: 'onboardingFormTouched',
};

export const setLSItem = (key, value) => window.localStorage.setItem(key, value);

export const getLSItem = (key) => window.localStorage.getItem(key);

export const removeLSItem = (key) => window.localStorage.removeItem(key);

export const clearLS = () => window.localStorage.clear();

export const getLSKey = (index) => window.localStorage.key(index);

export const getQueryParamsLS = (key) => {
  let result = {};
  if (getLSItem(keysLS[key])) {
    result = JSON.parse(getLSItem(keysLS[key]));
  }

  return result;
};

export const updateQueryParamsLS = (key, obj) => {
  let params = getQueryParamsLS(key);
  params = { ...params, ...obj };
  setLSItem(key, JSON.stringify(params));
};
